import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

export const PessoaEvolucao = ({ pessoa, onClose }) => {
  const [evolucao, setEvolucao] = useState(pessoa?.descricao || "");

  useEffect(() => {
    if (!pessoa) return;
    setEvolucao(pessoa.descricao);
  }, [pessoa]);

  if (!pessoa) return null;

  return (
    <Dialog open={true} onClose={() => onClose(null)} fullWidth maxWidth="md">
      <DialogTitle>Evolução de {pessoa?.nome}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          multiline
          rows={5}
          value={evolucao}
          onChange={(e) => setEvolucao(e.target.value)}
          margin="normal"
          variant="outlined"
          placeholder="Descreva a evolução do paciente..."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(null)}>Cancelar</Button>
        <Button onClick={() => onClose(evolucao)} variant="outlined">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
